module.exports = __webpack_public_path__ + "img/bj17.af37e61f.png";